/* import __COLOCATED_TEMPLATE__ from './suggestion-overview-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type PulseAccordionSection } from 'glint/pulse';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
    isOpen: boolean;
    description: string;
    suggestionType: string;
    onOpenSection?: (sectionId: string) => void;
  };
}

export default class SuggestionOverviewItem extends Component<Signature> {
  @service declare appService: AppService;

  get formattedActionDescription() {
    if (!this.args.description) {
      return '';
    }
    return sanitizeHtml(this.args.description);
  }

  get whatItDoesActionDescription() {
    let formatted = this.formattedActionDescription;
    if (!formatted) {
      return '';
    }
    let description = this.args.description;
    if (!description) {
      return '';
    }
    // Look for "What it does:" followed by content until we hit a delimiter:
    // - HTML closing tag (</p>)
    // - Triple dash separator (---)
    // - Another section heading (When to use:, How it works:, etc.)
    // - End of string
    let whatItDoesMatch = description.match(
      /What it does:\s*(.+?)(?=\s*(?:<\/p>|---|When to use:|$))/is,
    );
    return whatItDoesMatch ? whatItDoesMatch[1].trim() : '';
  }

  get whenToUseActionDescription() {
    let formatted = this.formattedActionDescription;
    if (!formatted) {
      return '';
    }
    let description = this.args.description;
    if (!description) {
      return '';
    }
    // Look for "When to use:" followed by content until we hit a delimiter:
    // - HTML closing tag (</p>)
    // - Triple dash separator (---)
    // - Another section heading (What it does:, How it works:, etc.)
    // - End of string
    let whenToUseMatch = description.match(
      /When to use:\s*(.+?)(?=\s*(?:<\/p>|---|What it does:|$))/is,
    );
    return whenToUseMatch ? whenToUseMatch[1].trim() : '';
  }

  get isDataGap() {
    return this.args.suggestionType === 'data-gap';
  }

  get shouldShowProcedure() {
    let hasProcedures = this.appService.app.canUseFinProcedures;
    let hasTasks = this.appService.app.canUseAiAgentWorkflows;

    // Show procedure in all cases EXCEPT when only tasks is enabled
    // - If procedures enabled (with or without tasks) → show procedure
    // - If both disabled → show procedure
    // - If only tasks enabled → DON'T show procedure
    return hasProcedures || !hasTasks;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionOverviewItem': typeof SuggestionOverviewItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-overview-item': typeof SuggestionOverviewItem;
  }
}
